import React from "react";
import { Reveal } from "../lib/ui";

const COA_IMG =
  "https://static.prod-images.emergentagent.com/jobs/17006009-5ae1-416a-a126-519749023e8c/images/3eca698659501ef8a6b09171c5f1228a7523c0d7538f22789215b06c4dfd4105.jpeg";

const STATS = [
  { k: "> 99%", v: "Avg. HPLC Purity" },
  { k: "3rd Party", v: "Verified Assays" },
  { k: "< 0.05", v: "EU/µg Endotoxin" },
  { k: "100%", v: "COA-Backed Batches" },
];

export const CoaScience = () => (
  <section id="coa" data-testid="coa-science" className="scroll-mt-32 bg-sand px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto grid max-w-[1500px] gap-16 lg:grid-cols-2 lg:items-center">
      <Reveal>
        <div className="relative border border-line corner-bracket">
          <div className="absolute inset-0 spotlight z-[1]" />
          <img src={COA_IMG} alt="Laboratory analysis" className="relative aspect-[4/5] w-full object-cover" />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-rust">[ Certificate of Analysis ]</p>
          <h2 className="mt-6 font-display text-5xl leading-[0.9] tracking-tighter text-ink md:text-7xl">
            The numbers travel<br />with the vial.
          </h2>
          <p className="mt-8 max-w-lg font-body text-lg leading-relaxed text-ink/70">
            Every batch ships with a printed Certificate of Analysis: HPLC purity, mass-spec confirmation,
            endotoxin load, and appearance — signed, dated, and traceable to the lot.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 border-l border-t border-line">
          {STATS.map((s, i) => (
            <Reveal key={s.v} delay={i * 0.07}>
              <div className="border-b border-r border-line p-6 md:p-8">
                <p className="font-display text-4xl leading-none text-ink md:text-5xl">{s.k}</p>
                <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.15em] text-ink/50">{s.v}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
